import Page from "~/components/Page";
import Section from "~/components/Section";
import Container from "~/components/Container";
import css from "./home.module.css"

export default function HomePage() {

    return (
        <Page class={css.homePage}
              metaTitle="Yoga Classes in Catshill, Bromsgrove"
              metaDescription="Breathe. Flow. Reconnect. Join Graceful Space Yoga for Vinyasa flow classes in Catshill Village Hall. Book online and discover your yoga journey.">
            <Section class={css.hero}>
                <img class={css.bannerImg} src="/banner.webp" alt="Person Meditating"/>
                <Container class={css.heroContent}>
                    {/*<h1>Yoga Classes</h1>*/}
                    <p>Welcome to Graceful Space Yoga</p>
                </Container>
            </Section>
            <Section class={css.introductionSection}>
                <Container class={css.introduction}>
                    <h2>Breathe. Flow. Reconnect.</h2>
                    <p>
                        At Graceful Space Yoga, <br/>
                        graceful isn’t about being perfect — it’s about being kind to yourself. Here, grace means
                        meeting yourself with gentleness, patience, and compassion. We welcome you onto your mat, a safe
                        space where mindful movement and deep breathing help you to reconnect with yourself.
                    </p>
                </Container>
            </Section>
            <Section>
                <Container>
                    <div class={css.aboutMe}>
                        <h2>Meet your teacher</h2>
                        <img src="/heather.webp" alt="Heather" class={css.heatherImg}/>
                        <p>Hi I'm Heather,<br/>
                            It truly means the world to me that you’re here. Teaching yoga is
                            something I hold close to my heart — I’ve been sharing this practice since graduating
                            from
                            my 200hr Yoga Teacher training in 2023. But really, the journey began much earlier. As a
                            child, I found comfort in the quiet magic of movement — often drifting into dance and
                            music,
                            where time seemed to pause and presence took its place. Flowing movements that speak
                            without
                            words, guiding us home to ourselves. Though life carried me in another direction, yoga
                            found
                            me when I needed it most, the flowing rhythm of postures and breath felt like a
                            long-lost
                            memory returning home. Through my own journey of healing and navigating mental health,
                            my
                            yoga practice became my safe space and a soft place to land. That’s what I hope to offer
                            you, too: a warm, welcoming space where you feel held, seen, and gently guided back to
                            your
                            own heart.
                        </p>
                        <div class={css.signoff}>
                            <p>With gratitude & grace,</p>
                            <p class={css.signature}>Heather</p>
                        </div>
                    </div>
                </Container>
            </Section>
        </Page>
    )
}